import { mixin as mixin_1 } from "./component-library262.mjs";
import Openable from "./component-library263.mjs";
const Dismissable = {
  mixins: [mixin_1, Openable],
  emits: ["clickaway"],
  methods: {
    async onClickaway() {
      if (this.isClosed)
        return false;
      await this.close();
      this.$emit("clickaway");
      return true;
    },
    onEsc() {
      return this.close();
    }
  }
};
export {
  Dismissable as default
};
